import { useJournalStore } from '../hooks/useJournalStore';
import type { WidgetProps } from './WidgetRegistry';
import type { ContinuationStatus } from '../types';

const STATUS_COLORS: Record<ContinuationStatus, string> = {
  created: 'text-tower-accent',
  running: 'text-tower-success',
  sleeping: 'text-tower-warning',
  waiting: 'text-warning',
  blocked: 'text-tower-danger',
  merged: 'text-purpleToken',
  done: 'text-success',
  killed: 'text-error',
  failed: 'text-tower-danger',
};

export function StatusBoardWidget(_props: WidgetProps) {
  const journal = useJournalStore((s) => s.activeJournal);
  if (!journal) return <div className="text-tower-muted text-sm p-3">No journal loaded</div>;

  const all = [journal.rootContinuation, ...journal.descendants];
  const byStatus = new Map<ContinuationStatus, number>();
  for (const c of all) byStatus.set(c.status, (byStatus.get(c.status) || 0) + 1);

  return (
    <div className="p-3 space-y-2">
      <div className="grid grid-cols-3 gap-2">
        <Stat label="Active" value={journal.activeCount} color="text-tower-success" />
        <Stat label="Sleeping" value={journal.sleepingCount} color="text-tower-warning" />
        <Stat label="Waiting" value={journal.waitingCount} color="text-warning" />
      </div>
      <div className="border-t border-tower-border pt-2 space-y-1">
        {Array.from(byStatus.entries())
          .sort((a, b) => b[1] - a[1])
          .map(([status, count]) => (
            <div key={status} className="flex justify-between text-xs">
              <span className={STATUS_COLORS[status]}>{status}</span>
              <span className="text-tower-text font-mono">{count}</span>
            </div>
          ))}
      </div>
      <div className="text-xs text-tower-muted pt-1">
        {all.length} total continuations &middot; {journal.findings.length} findings
      </div>
    </div>
  );
}

function Stat({ label, value, color }: { label: string; value: number; color: string }) {
  return (
    <div className="text-center">
      <div className={`text-2xl font-mono font-bold ${color}`}>{value}</div>
      <div className="text-xs text-tower-muted">{label}</div>
    </div>
  );
}
